import React from 'react';
import { SCHEMATIC_LEGEND, SLOT_COLOR_PRESETS } from '../../../helpers/siteMapSlotHelpers';
import SiteMapSchematic from './SiteMapSchematic';

const SiteMapPrintSheet = ({ site, occupiedCount, totalSlots, printedAt, mapSize = null }) => (
  <div
    className={`site-map-print-sheet${mapSize ? ' site-map-print-sheet--sized' : ''}`}
    style={
      mapSize
        ? {
            width: mapSize.width,
            '--print-map-width': `${mapSize.width}px`,
            '--print-map-height': `${mapSize.height}px`
          }
        : undefined
    }
  >
    <div className="site-map-print-header">
      <h5 className="mb-1">Site Map — {site?.name}</h5>
      <div className="small text-muted">
        <span>
          <strong>{occupiedCount}</strong> of <strong>{totalSlots}</strong> slots occupied
        </span>
        <span className="mx-2">|</span>
        <span>Printed {printedAt}</span>
      </div>
    </div>

    <div className="site-map-print-schematic">
      <SiteMapSchematic
        slots={site?.slots || []}
        className="site-map-print-schematic-svg"
        mapSize={mapSize}
      />
    </div>

    <div className="site-map-print-legend">
      {SCHEMATIC_LEGEND.map(({ key, label }) => (
        <div key={key} className="site-map-print-legend-item">
          <span
            className="site-map-print-legend-swatch"
            style={{ backgroundColor: SLOT_COLOR_PRESETS[key].fill }}
          />
          <span>{label}</span>
        </div>
      ))}
    </div>

    <div className="site-map-print-footer">Schematic view — slot shapes only, not to scale for surveying.</div>
  </div>
);

export default SiteMapPrintSheet;
